import React from "react";
import axios from "axios";

export const delay = ms => new Promise(res => setTimeout(res, ms));

export function getMonthName(month){
    return ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'aout', 'septembre', 'octobre', 'novembre', 'décembre'][month-1];
}

export function getFormatedDate(date){
    return getMonthName(date.substr(5,2)) + ' ' + date.substr(0,4);
}

export function log(str){
    const queryParams = new URLSearchParams(window.location.search);
    //if(queryParams.get('dev')){
    console.log(str);
    //}
}

/* Revendeurs :
    3  		: Forever FR
    72 		: VP FR
    11, 90 	: France loisirs
    54		: Tedeo FR

    1,62	: Carrefour
    13		: Fnac
    23		: Leclerc
*/

export function getResellerData(reseller_id){
    if(reseller_id == 1 || reseller_id == 62){
        return {
            "resellerId" : reseller_id,
            "pageTitle": 'Carrefour - Service numérisation',
            "style": "styles/carrefour.css",
            "logoUrl": "https://www-for-ever-com.netlify.app/numerisation.carrefour.fr/images/upsale/logo_carrefour.png",
            "favIconUrl": "https://www-for-ever-com.netlify.app/numerisation.carrefour.fr/images/favicon/favicon-16x16.png"
        }
    } else if(reseller_id == 13) {
        return {
            "resellerId" : reseller_id,
            "pageTitle": 'FNAC Numérisation France',
            "style": "styles/fnac.css",
            "logoUrl": "https://www-for-ever-com.netlify.app/numerisation.fnac.com/images/upsale/logo_fnac.png",
            "favIconUrl": "https://www-for-ever-com.netlify.app/numerisation.fnac.com/images/favicon/favicon-16x16.png"
        }
    } else if(reseller_id == 23) {
        return {
            "resellerId" : reseller_id,
            "pageTitle": "Leclerc - Service numérisation",
            "style": "styles/leclerc.css",
            "logoUrl": "https://www-for-ever-com.netlify.app/numerisation.leclerc/images/upsale/logo_leclerc.png",
            "favIconUrl": "https://www-for-ever-com.netlify.app/numerisation.leclerc/images/favicon/favicon-16x16.png"
        }
    } else{
        return {
            "resellerId" : reseller_id,
            "logoUrl": "https://www-for-ever-com.netlify.app/fr.for-ever.com/images/logo.svg",
            "favIconUrl": "https://www-for-ever-com.netlify.app/fr.for-ever.com/images/favicon/favicon-16x16.png"
        }
    }
}

export function convertUnicode(input) {
    return input.replace(/\\+u([0-9a-fA-F]{4})/g, (a,b) =>
        String.fromCharCode(parseInt(b, 16)));
}

export async function isExists(url, montage = 'VIDEO04') {
    if(montage == 'VIDEO03'){
        url = url.toString().replace('VIDEO04','VIDEO03');
    }else if(montage == 'VIDEO05'){
        url = url.toString().replace('VIDEO03','VIDEO05');
    }
    return axios.get(url, {
        mode: 'no-cors',
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        },
        withCredentials: false
    })
        .then(r => {
            return url;
        }).catch(async error => {
            if(montage == 'VIDEO05'){log(error);return false;}
            else if(montage == 'VIDEO04'){montage = 'VIDEO03';}
            else if(montage == 'VIDEO03'){montage = 'VIDEO05';}
            return await isExists(url, montage);
        });
}

export function convertToGB(a) {
    return (a / (1024 * 1024 * 1024)).toFixed(3);
}

export function dateDiffInDays(a, b) {
    const _MS_PER_DAY = 1000 * 60 * 60 * 24;
    // Discard the time and time-zone information.
    const utc1 = Date.UTC(a.getFullYear(), a.getMonth(), a.getDate());
    const utc2 = Date.UTC(b.getFullYear(), b.getMonth(), b.getDate());

    return Math.floor((utc2 - utc1) / _MS_PER_DAY);
}

export function durationToSeconds(duration) {
    const [hours, minutes, seconds] = duration.split(":").map(Number);
    return hours * 3600 + minutes * 60 + seconds;
}
